__turbopack_context__.v({
  "className": "roboto_serif_5ee6983a-module__KhcoUG__className",
});
